import { EmbeddedCheckoutProvider, EmbeddedCheckout } from "@stripe/react-stripe-js";
import { useCallback } from "react";
import { getStripe } from "@/lib/stripe";

interface Props {
  /** Fetches a fresh Stripe Checkout client_secret. The provider keeps it stable per mount. */
  fetchClientSecret: () => Promise<string>;
  onComplete?: () => void;
}

export function StripeEmbeddedCheckout({ fetchClientSecret, onComplete }: Props) {
  const stable = useCallback(fetchClientSecret, [fetchClientSecret]);
  return (
    <div id="checkout" className="rounded-2xl border border-border bg-card/30 p-2 sm:p-4">
      <EmbeddedCheckoutProvider
        stripe={getStripe()}
        options={{ fetchClientSecret: stable, onComplete }}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  );
}